import { useTheme } from 'styled-components';

import { FormattedMessage } from 'react-intl';

import { useModals } from 'context';

import { Modal } from 'components';
import Warning from 'images/warning.svg';

import { DeviceWarningProps } from './types';
// eslint-disable-next-line import/order
import { YogaTheme } from 'types/others';

import * as S from './styles';

const DeviceWarning: React.FC<DeviceWarningProps> = ({
  isOpen,
  modalKey,
  props: { onConsent },
}) => {
  const { closeModal } = useModals();
  const theme = useTheme() as YogaTheme;

  const handleCloseModal = () => {
    onConsent();
    closeModal(modalKey);
  };

  return (
    <Modal
      isOpen={isOpen}
      data-testid="device-warning-modal"
      showCloseButton={false}
      closeModal={handleCloseModal}
      overlayStyle={{ alignContent: 'center', zIndex: 999 }}
      contentStyle={{
        margin: '0',
        paddingTop: '0',
        width: '100vw',
        height: '100vh',
        maxHeight: 'unset',
        maxWidth: 'unset',
        border: 'unset',
        borderRadius: '0',
        background: theme.yoga.colors.backgroundLight,
        paddingBottom: `${theme.yoga.spacing.xxlarge}px`,
      }}
    >
      <S.Container data-testid="device-warning-modal-container">
        <S.WarningContainer>
          <Warning />
          <S.Title data-testid="device-warning-modal-continue-title">
            <FormattedMessage id="SIGNIN.CP.MODAL.TITLE.DEVICE" />
          </S.Title>
          <S.Subtitle data-testid="device-warning-modal-continue-subtitle">
            <FormattedMessage id="SIGNIN.CP.MODAL.SUBTITLE.DEVICE" />
          </S.Subtitle>
        </S.WarningContainer>
        <S.Button
          onClick={handleCloseModal}
          data-testid="device-warning-modal-continue-button"
        >
          <FormattedMessage id="SIGNIN.CP.MODAL.BUTTON.DEVICE" />
        </S.Button>
      </S.Container>
    </Modal>
  );
};

export default DeviceWarning;
